import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

/**
 * "Übergabe"-Symbol: a car presented on an open, cupped hand.
 * First-draft icon for the takeover/Übernahmebestätigung action (OQ-8 — UX/design may still refine it).
 */
export function HandoverIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      {/* car: cabin + body */}
      <rect x="6.6" y="2.8" width="10.8" height="5.4" rx="1.6" />
      <rect x="3.4" y="6.4" width="17.2" height="5.4" rx="1.8" />
      {/* wheels */}
      <circle cx="8" cy="12" r="1.6" />
      <circle cx="16" cy="12" r="1.6" />
      {/* open, cupped hand presenting the car */}
      <path d="M1.8 14.3c.95-.2 1.83.35 2.25 1.2C5.4 18.25 8.45 20 12 20s6.6-1.75 7.95-4.5c.42-.85 1.3-1.4 2.25-1.2v.75C21.1 19.4 16.9 22.4 12 22.4S2.9 19.4 1.8 15.05Z" />
    </SvgIcon>
  );
}
